/* Hamburgermenyn (snippets/NV-MENY.liquid): öppna, stänga, paneler och tangentbord. */
(function () {
  var root = document.getElementById('nv-meny');
  if (!root || root.dataset.init === 'true') return;
  root.dataset.init = 'true';

  // Flytta menyn till <body> så att den aldrig hamnar under headerns
  // stacking context. Vid omladdning i temaredigeraren tas gamla kopior bort.
  Array.prototype.forEach.call(document.querySelectorAll('body > .nv-meny'), function (el) {
    if (el !== root) el.parentNode.removeChild(el);
  });
  if (root.parentNode !== document.body) document.body.appendChild(root);

  // Momsreglaget: tillstånd och namn från det gemensamma valet (NV-MOMS),
  // klick och tangenter sköts där
  if (window.NVMoms) window.NVMoms.syncSwitches(root);

  var drawer = root.querySelector('.nv-meny__drawer');
  var closeBtn = root.querySelector('.nv-meny__close');
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-nv-meny-panel]'));
  var mq = window.matchMedia('(max-width: 999px)');
  var lastTrigger = null;
  var resetTimer;

  // Hämta bilderna i en panel (eller i huvudet) först när de behövs
  function loadImages(container) {
    if (!container) return;
    Array.prototype.forEach.call(container.querySelectorAll('img[data-nv-src]'), function (img) {
      img.src = img.getAttribute('data-nv-src');
      img.removeAttribute('data-nv-src');
    });
  }

  function openers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-nv-meny-open]'));
  }
  function level(p) { return parseInt(p.getAttribute('data-level'), 10) || 1; }
  function isOpen(p) { return level(p) === 1 || p.classList.contains('is-open'); }

  function closeFromLevel(lvl) {
    panels.forEach(function (p) {
      if (level(p) >= lvl && p.classList.contains('is-open')) {
        p.classList.remove('is-open');
        if (p._nvTrigger) {
          p._nvTrigger.setAttribute('aria-expanded', 'false');
          p._nvTrigger.classList.remove('is-active');
        }
      }
    });
  }

  // På mobilen täcks underliggande paneler, så de görs inerta.
  function updateInert() {
    var top = panels[0];
    panels.forEach(function (p) {
      if (isOpen(p) && level(p) > level(top)) top = p;
    });
    panels.forEach(function (p) {
      if (mq.matches && p !== top) {
        p.setAttribute('inert', '');
      } else {
        p.removeAttribute('inert');
      }
    });
  }

  function openPanel(btn) {
    var p = document.getElementById(btn.getAttribute('data-nv-meny-target'));
    if (!p) return;
    var lvl = level(p);
    // Andra klicket på en rad vars kolumn redan är öppen går till
    // kollektionen (t.ex. Frysar, sedan Frysar igen). Första klicket
    // öppnar bara kolumnen. Saknar raden egen sida står kolumnen kvar.
    if (p.classList.contains('is-open') && p._nvTrigger === btn) {
      var url = btn.getAttribute('data-nv-meny-url');
      if (url && url.charAt(0) !== '#') window.location.href = url;
      return;
    }
    closeFromLevel(lvl);
    p._nvTrigger = btn;
    loadImages(p);
    p.scrollTop = 0;
    p.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-active');
    updateInert();
    if (mq.matches) {
      var back = p.querySelector('[data-nv-meny-back]');
      if (back) back.focus({ preventScroll: true });
    }
  }

  function goBack(btn) {
    var p = btn.closest('[data-nv-meny-panel]');
    if (!p) return;
    var trigger = p._nvTrigger;
    closeFromLevel(level(p));
    updateInert();
    if (trigger) trigger.focus({ preventScroll: true });
  }

  function focusables() {
    return Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled])')
    ).filter(function (el) {
      if (el.closest('[inert]')) return false;
      if (!el.getClientRects().length) return false;
      return getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      // Escape stänger bara den djupaste öppna nivån och lämnar fokus på
      // raden som öppnade den. Först på översta nivån stängs hela menyn.
      var deepest = null;
      panels.forEach(function (p) {
        if (level(p) > 1 && p.classList.contains('is-open') &&
            (!deepest || level(p) > level(deepest))) deepest = p;
      });
      if (deepest) {
        var trigger = deepest._nvTrigger;
        closeFromLevel(level(deepest));
        updateInert();
        if (trigger) trigger.focus({ preventScroll: true });
      } else {
        closeMenu();
      }
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  }

  function openMenu(trigger) {
    if (window.NVPanel && NVPanel.opening) NVPanel.opening('meny');
    clearTimeout(resetTimer);
    lastTrigger = trigger || null;
    loadImages(root.querySelector('.nv-meny__head'));
    loadImages(panels[0]);
    root.classList.add('is-open');
    document.body.classList.add('nv-meny-open');
    openers().forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.addEventListener('keydown', onKey);
    updateInert();
    closeBtn.focus({ preventScroll: true });
  }

  function closeMenu() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.body.classList.remove('nv-meny-open');
    openers().forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', onKey);
    // Nästa gång börjar menyn om från första nivån
    resetTimer = setTimeout(function () {
      closeFromLevel(2);
      updateInert();
    }, 440); /* lite längre än --nv-panel-speed-out (0.4 s), menyn hinner glida ut först */
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    // En äldre kopia (efter omladdning i temaredigeraren) gör ingenting
    if (!root.isConnected) return;
    var opener = e.target.closest('[data-nv-meny-open]');
    if (opener) {
      e.preventDefault();
      openMenu(opener);
      return;
    }
    if (!root.contains(e.target)) return;
    if (e.target.closest('[data-nv-meny-close]')) {
      e.preventDefault();
      closeMenu();
      return;
    }
    var back = e.target.closest('[data-nv-meny-back]');
    if (back) {
      goBack(back);
      return;
    }
    var row = e.target.closest('[data-nv-meny-target]');
    if (row) {
      openPanel(row);
      return;
    }
    // Ankarlänkar på samma sida (t.ex. #newsletter) stänger menyn
    var link = e.target.closest('a[href^="#"]');
    if (link) closeMenu();
  });

  // En panel i taget: snippets/NV-PANEL-CORE.liquid
  if (window.NVPanel && NVPanel.register) {
    NVPanel.register('meny', function () { return root.isConnected && root.classList.contains('is-open'); }, closeMenu);
  }

  var onChange = function () { updateInert(); };
  if (mq.addEventListener) { mq.addEventListener('change', onChange); }
  else if (mq.addListener) { mq.addListener(onChange); }

  // Stäng om sidan visas från bakåt-cachen med menyn öppen
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) closeMenu();
  });
})();
